import { useCallback, useRef } from 'react';
import pEachSeries from 'p-each-series';
import pRetry from 'p-retry';
export const useSequentialTasks = items => {
  const cached = useRef({});
  const runTasks = useCallback(async () => {
    return pEachSeries(items, async (item, itemIndex) => {
      try {
        const runTask = async (task, key) => {
          if (!cached.current[key]) {
            await pRetry(task.task, {
              retries: task.retries ?? 0,
              minTimeout: 2 * 1000,
              factor: 1
            });
            cached.current[key] = true;
          }
        };
        if (Array.isArray(item)) {
          await Promise.all(item.map((task, taskIndex) => runTask(task, `${itemIndex}:${taskIndex}`)));
        } else {
          await runTask(item, itemIndex.toString());
        }
      } catch (error) {
        throw error;
      }
    });
  }, [items]);
  return {
    runTasks
  };
};
//# sourceMappingURL=useSequentialTasks.js.map